export const SEN_EXPERT_REQUESTED_BY_CARER =
  "A SEN expert has been requested to attend by the pupil's parent/carer(s)";
export const SEN_EXPERT_NOT_REQUESTED_BY_CARER =
  "A SEN expert has not been requested to attend by the pupil's parent/carer(s)";
export const MEETING_REQUESTED_BY =
  'The meeting was requested on the {0} by {1}';
export const ERROR_GETTING_MEETING_DETAILS =
  'Error getting the meeting details';
export const GOVERNING_BODY_MEETING = 'Governing Body Meeting';
export const INDEPENDENT_PANEL_APPEAL_MEETING =
  'Independent Panel Appeal Meeting';
export const MEETING_REQUEST_CARER = "the pupil's parent/carer";
export const MEETING_ATTENDANCE_CARER = "Pupil's parent";
export const MEETING_ATTENDANCE_SEN_EXPERT = '{0} (SEN Expert)';
export const MEETING_ATTENDANCE_OFFICER = '{0} (Officer)';
export const TRUE_VALUE = 'True';
